/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getUnpaidCompletedWorkReportQueryParams = zod.object({
  "fsmConnectionId": zod.string().uuid().optional(),
  "dateBasis": zod.enum(['CompletionDate', 'RequestCreatedDate']).optional(),
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional(),
  "payeeType": zod.enum(['User', 'Organization']).optional(),
  "payeeId": zod.string().uuid().optional(),
  "techEmail": zod.string().optional(),
  "statuses": zod.array(zod.enum(['NotPayable', 'NotReady', 'NotEvaluated', 'AwaitingSync', 'AwaitingTechMapping', 'SyncFailed', 'SyncAbandoned', 'AwaitingPayoutRequest', 'PayoutRequestPending', 'PayoutRequestReturned', 'PayoutRequestDenied', 'PayoutRequestApproved', 'PayoutScheduled', 'PaymentInProgress', 'PaymentFailed', 'PayoutVoided', 'Paid'])).optional()
})

export const getUnpaidCompletedWorkReportResponse = zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "dateBasis": zod.enum(['CompletionDate', 'RequestCreatedDate']),
  "startDate": zod.string().datetime({}),
  "endDate": zod.string().datetime({}),
  "lastSyncedAt": zod.string().datetime({}).nullish(),
  "lines": zod.array(zod.object({
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payeeName": zod.string().nullish(),
  "techEmail": zod.string().nullish(),
  "techName": zod.string().nullish(),
  "externalType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "externalId": zod.string(),
  "completedAt": zod.string().datetime({}),
  "payoutRequestId": zod.string().uuid().nullish(),
  "requestCreatedDate": zod.string().datetime({}).nullish(),
  "customerName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "description": zod.string().nullish(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['NotPayable', 'NotReady', 'NotEvaluated', 'AwaitingSync', 'AwaitingTechMapping', 'SyncFailed', 'SyncAbandoned', 'AwaitingPayoutRequest', 'PayoutRequestPending', 'PayoutRequestReturned', 'PayoutRequestDenied', 'PayoutRequestApproved', 'PayoutScheduled', 'PaymentInProgress', 'PaymentFailed', 'PayoutVoided', 'Paid']),
  "explanation": zod.string(),
  "nextStep": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish()
}))
})

